//chnage mobile number
export const CHANGE_MOBILE_NUMBER_REQUEST = "CHANGE_MOBILE_NUMBER_REQUEST";
export const CHANGE_MOBILE_NUMBER_RECEIVE = "CHANGE_MOBILE_NUMBER_RECEIVE";
export const CHANGE_MOBILE_NUMBER_FAILURE = "CHANGE_MOBILE_NUMBER_FAILURE";
export const RESET_CHANGE_MOBILE_NUMBER= "RESET_CHANGE_MOBILE_NUMBER";